<div class="container-fluid">
    <div class="row">
        <div class="group-btn col-md-{{env.deviceType() ? '8' : '9'}}">
            <button (click)="assignmentList(3)" [ngClass]="{'active1': filterType == 3}" class="btn btn-outline-primary {{env.deviceType() ? 'border-radius-20' : ''}}" type="button">In progress</button>
            <button (click)="assignmentList(4)" [ngClass]="{'active1': filterType == 4}" class="btn btn-outline-primary {{env.deviceType() ? 'border-radius-20' : ''}}" type="button">Completed</button>
            <button (click)="assignmentList(1)" [ngClass]="{'active1': filterType == 1}" class="btn btn-outline-primary {{env.deviceType() ? 'border-radius-20' : ''}}" type="button">All</button>
        </div>
        <div class="col-md-{{env.deviceType() ? '4' : '3'}} btn-popup pull-right">
            <div class="input-group">
                <input class="form-control" placeholder="Search by Assignment name" size="50" [ngStyle]="{'height' : env.deviceType() ? '34px' : '40px'}" type="text" [(ngModel)]="searchAssign" (input)="updateFilter(searchAssign)">
                <div class="input-group-append">
                    <button class="btn btn-primary  {{env.deviceType() ? 'py-0 border-radius-2' : ''}}" type="submit"><i aria-hidden="true" class="fa fa-search"></i></button>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center list-card mt-5" *ngIf="listData.length ==0">
        <div class="col-4">
            <button class="nodataList">No Assignment Available !</button>
        </div>
    </div>
    <section class="row list-card mt-2" *ngIf="listData.length !=0">
        <div class="col-md-12">
            <div *ngFor="let list of listData" class="card class-hover class-card" (click)="answerPage(list)">
                <div class="card-body {{env.deviceType() ? 'p-2' : ''}}">
                    <div class="row {{env.deviceType() ? 'mt-1' : ''}}">
                        <div class="col-1 d-flex justify-content-center align-items-center">
                            <figure class="cursor" title="Preview">
                                <img *ngIf="list.profile_url == ''" alt="" class="img-50 rounded-circle" src="assets/images/ristaschool/option-writing-checkbox-concepts-survey.png" >
                                <img *ngIf="list.profile_url != ''" [src]="sanitizer.bypassSecurityTrustResourceUrl(webhost + '/' + list.profile_url)" alt="" class="img-50 rounded-circle">
                            </figure>
                        </div>
                        <div class="col-6">
                            <h4 class="t-period">
                                <span *ngIf="list.student_content_status == 1 && list.overdueStatus" class="badge badge-secondary">Not started</span>
                                <span *ngIf="list.student_content_status == 1 && !list.overdueStatus" class="badge badge-danger">Overdue</span>
                                <span *ngIf="list.student_content_status == 2" class="badge badge-warning">In-Progress</span>
                                <!--                                <span *ngIf="list.student_content_status != 2 && list.student_content_status != 1" class="badge badge-success">Completed</span>-->
                                <span *ngIf="list.student_content_status == '3'" class="badge badge-primary">Score Released</span>
                                <span *ngIf="list.student_content_status == '4' || list.student_content_status == '6'" class="badge badge-info">Correction Pending</span>
                                <span *ngIf="list.student_content_status == '5'" class="badge badge-success">Correction Completed</span>
                                &nbsp; <span class="font-weight-bold">{{list.content_name}}</span></h4>
                            <div class="d-flex">
                                <p><span>Subject: </span> <span class="t-name font-weight-bold">{{list.subject_name}}</span></p>
                                <p class="ml-4"><span>Class: </span> <span class="t-name font-weight-bold">{{list.class_name}}</span></p>
                                <p *ngIf="list.student_content_status == '3'" class="ml-4"><span>Teacher: </span> <span class="t-name font-weight-bold">{{list.teacher_first_name}} {{list.teacher_last_name}}</span></p>
                            </div>
                        </div>
                        <div class="col-5 align-self-center">
                            <div class="row d-flex align-items-center">
                                <div class="col-12">
                                    <p class="text-right mb-1">&nbsp;<span class="total-score">End Date: </span>
                                        <span *ngIf="list.end_date != '0000-00-00'" class="t-name font-weight-bold">
                                            {{list.end_date | date:'MM/dd/yyyy'}}, {{list.end_time}}</span>&nbsp;
                                        <span *ngIf="list.overdue != 0 && !list.overdueStatus" class="total-score">Overdue For:
                                        <span *ngIf="list.overdue != 1" class="over-due1">{{list.overdue}} Days</span></span>
                                        <span *ngIf="list.overdue != 0 && list.overdueStatus" class="total-score">Due In:
                                        <span *ngIf="list.overdue != 1" class="due-in">{{list.overdue}} Days</span></span>
                                    </p>
                                    <p class="text-right" *ngIf="list.student_content_status == '3'">
                                        <span class="total-score">Obtained Score: <span class="t-name">{{list.obtained_score}}</span></span>&nbsp;
                                        <span class="total-score">Total Score: <span class="t-name">{{list.total_score}}</span></span>
                                    </p>
                                </div>
                                <div class="col-12 text-right mt-1" *ngIf="list.student_content_status == '3' && list.content_format == 3 && list.is_test == '1'" >
                                    <button (click)="navigateToSATReport(list, $event)" class="btn btn-outline-primary px-3">
                                        <i title="View Analytics" style="font-size: 20px" class="fa fa-bar-chart color-primary cursor"
                                           aria-hidden="true"></i>View Analytics</button>
                                </div>
                                <div class="col-12 text-right mt-1" *ngIf="list.allow_answer_key == '1' && list.student_content_status == '3' && list.downloadPDF.length != 0">
                                    <button (click)="viewAnswerKeyPdf($event, list)" class="btn btn-outline-primary px-3"><i class="fa fa-key mr-1" aria-hidden="true"></i>Answer Key & Explanation</button>
                                </div>
                            </div>
                        </div>
<!--                        <div class="col-5">-->
<!--                            <div class="row align-self-end">-->
<!--                                <div class="col-md-12">-->
<!--                                    <p class="text-right">-->
<!--                                        &nbsp;<span class="total-score">End Date: </span> <span *ngIf="list.end_date != '0000-00-00'" class="t-name font-weight-bold">{{list.end_date|date:'MM/dd/yyyy'}}, {{list.end_time}}</span>&nbsp;-->
<!--                                        <span *ngIf="list.overdue != 0 && !list.overdueStatus" class="total-score">Overdue For:-->
<!--                                            <span *ngIf="list.overdue != 1" class="over-due1">{{list.overdue}} Days</span>-->
<!--                                        </span>-->
<!--                                        <span *ngIf="list.overdue != 0 && list.overdueStatus" class="total-score">Due In:-->
<!--                                            <span *ngIf="list.overdue != 1" class="due-in">{{list.overdue}} Days</span>-->
<!--                                        </span>-->
<!--                                        <span class="total-score" *ngIf="list.student_content_status == '3'"><br/>Total Score: <span class="t-name">{{list.total_score}}</span></span>&nbsp;-->
<!--                                        <span class="total-score" *ngIf="list.student_content_status == '3'">Obtained Score: <span class="t-name">{{list.obtained_score}}</span></span></p>-->
<!--                                    <div class="dropdown pull-right" *ngIf="list.allow_answer_key == '1' && list.student_content_status == '3' && list.downloadPDF.length != 0">-->
<!--                                        <button class="btn btn-outline-primary">Action <i class="fa fa-sort-desc float-right ml-2" aria-hidden="true"></i></button>-->
<!--                                        <div class="dropdown-content" style="right: 1px">-->
<!--                                            <a (click)="checkFunction($event, list)"><i class="fa fa-key pl-1 pr-1" aria-hidden="true"></i> Answer Key & Explanation</a>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--&lt;!&ndash;                                    <button (click)="answerPage(list)" [disabled]="list.status == 1" class="btn-sm-i btn-outline-primary pull-right" type="button">Enter</button>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <button (click)="sendRequest(list, 1)" *ngIf="list.answer_request == 0 && list.student_content_status == '3' && list.downloadPDF.length != 0" class="btn-sm-i btn-outline-primary pull-right mr-2" title="Request PDF Download" type="button"><i class="fa fa-paper-plane"></i></button>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <button *ngIf="list.answer_request == 1 && list.student_content_status == '3' && list.downloadPDF.length != 0" class="btn-sm-i btn-outline-primary pull-right mr-2" readonly title="Request Pending" type="button"><i class="fa fa-spinner fa-spin"></i></button>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <button (click)="openAnswerKey(list)" *ngIf="list.allow_answer_key == '1' && list.student_content_status == '3' && list.downloadPDF.length != 0" class="btn-sm-i btn-outline-primary pull-right mr-2" title="Answer Key & Explanation" type="button"><i class="fa fa-key"></i></button>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span *ngIf="list.answer_request == 2 && list.student_content_status == '3'" class="fa-stack pull-right mr-2"><i class="fa fa-download fa-stack-1x"></i><i class="fa fa-ban fa-stack-2x text-danger"></i></span>&ndash;&gt;-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<ng-template #answerKey>
    <div class="modal-header">
        <h4 class="modal-title letter">Answer Key & Explanation</h4>
        <i (click)="onSave()" class="fa fa-close cursor"></i>
    </div>
    <div class="modal-body text-center">
        <pdf-viewer [src]="answerKeyPath" style="display: block;height: 100vh;"></pdf-viewer>
    </div>
</ng-template>

<ng-template #submitPopUp let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="contenttext text-center mb-0">Duration Completed</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <h5 class="mb-0">
                    <span>Test time is now complete. All your answers will be saved and submitted automatically</span></h5>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" type="submit" (click)="submitAnswer(contentData)">Ok</button>
    </div>
</ng-template>

<ng-template #submitTestPopUp let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="contenttext text-center mb-0">Duration Completed</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <h5 class="mb-0">
                    <span>Test time is now complete for {{testContentData?.module_name}}. All your answers will be saved
                        <span *ngIf="!testContentData?.lastQuestions"> , submitted  and moved to next content automatically.</span>
                        <span *ngIf="testContentData?.lastQuestions"> and submitted automatically.</span>
                    </span>
                </h5>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" type="submit" (click)="submitAnswer(testContentData, 'test')">Ok</button>
    </div>
</ng-template>

<ng-template #startTimerDuration let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="contenttext text-center mb-0">Start Timer Duration</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <h5 class="mb-0">
                    Click 'Ok' to start the assessment. Do not close the window once the assessment is started.
                </h5>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn cancel mr-1" (click)="onSave()">Cancel</button>
        <button class="btn btn-primary" type="submit" (click)="updateContentStatus(contentDetails)">Ok</button>
    </div>
</ng-template>

<ng-template #feedbackStatus>
    <div class="modal-body">
        <div class="col-12 px-0 my-3 d-flex flex-row align-items-center">
            <div class="feedback_spinner"></div>
            <span class="ml-3" style="font-size: 16px">{{popUpMessage}}</span>
        </div>
    </div>
</ng-template>

<ng-template #throwError>
    <div class="modal-header align-items-center">
        <h5 class="modal-title letter">{{ErrorTitle}}</h5>
        <i class="fa fa-close cursor" (click)="onSave()" ></i>
    </div>
    <div class="modal-body text-center">
        <p class="mb-0"><b>{{message}}</b></p>
    </div>
    <div class="modal-footer">
        <div class="pull-right">
            <button class="btn cancel mb-0" (click)="onSave()">ok</button>
        </div>
    </div>
</ng-template>

